export default "__VITE_ASSET__Dpmjf6Cp__"